import { useCommonDependency } from '../dependencies/common';

export const useEnv = (variableId: string) => {
  const env = useCommonDependency('env');

  return env[variableId] ?? null;
};
